module.exports = __webpack_public_path__ + "static/CircularStd-BookItalic-f1e69e389c1b9f463541c6e2f978d2a3.otf";